export const DEFAULT_TAX_CODES = [
    {id: 1, name:'Venta - IVA 0 %', value:'s_iva_0', readonly: false},
    {id: 2, name:'Gasto - IVA 0 %', value:'p_iva_0', readonly: false},
    {id: 3, name:'Gasto - IVA 21 % (deducible)', value:'p_iva_d_21', readonly: false},
    {id: 4, name:'Gasto - IVA 21 % (no deducible)', value:'p_iva_nd_21', readonly: false},
    {id: 5, name:'Gasto - IVA 7.5 %', value:'p_iva_75', readonly: false},
    {id: 6, name:'Gasto - IVA 5 %', value:'p_iva_5', readonly: false},
    {id: 7, name:'Gasto - IVA 2 %', value:'p_iva_2', readonly: false},
    {id: 8, name:'Gasto - IGIC 0 %', value:'p_igic_0', readonly: false},
    {id: 9, name:'Gasto - IGIC 3 %', value:'p_igic_3', readonly: false},
    {id: 10, name:'Gasto - IGIC 5 %', value:'p_igic_5', readonly: false},
    {id: 11, name:'Gasto - IGIC 7 %', value:'p_igic_7', readonly: false},
    {id: 24, name:'Gasto - IGIC 1 %', value:'p_igic_1', readonly: false},
    {id: 12, name:'Gasto - IGIC 9,5 %', value:'p_igic_9', readonly: false},
    {id: 13, name:'Gasto - IGIC 15 %', value:'p_igic_15', readonly: false},
    {id: 14, name:'Gasto - IGIC 20 %', value:'p_igic_20', readonly: false},
    {id: 15, name:'Venta - IGIC 0 %', value:'s_igic_0', readonly: false},
    {id: 16, name:'Venta - IGIC 3 %', value:'s_igic_3', readonly: false},
    {id: 17, name:'Venta - IGIC 5 %', value:'s_igic_5', readonly: false},
    {id: 18, name:'Venta - IGIC 7 %', value:'s_igic_7', readonly: false},
    {id: 25, name:'Venta - IGIC 1 %', value:'s_igic_1', readonly: false},
    {id: 19, name:'Venta - IGIC 9,5 %', value:'s_igic_9', readonly: false},
    {id: 20, name:'Venta - IGIC 15 %', value:'s_igic_15', readonly: false},
    {id: 21, name:'Venta - IGIC 20 %', value:'s_igic_20', readonly: false},
    {id: 22, name:'Gasto - IVA Prorata (deducible)', value:'p_iva_dp', readonly: false},
    {id: 23, name:'Gasto - IVA Prorata (no deducible)', value:'p_iva_ndp', readonly: false},
]


export const REVISO_TAX_CODES = [
    {id: 1, name:'Gasto - Exenta 0 %', value:'CEXE', readonly: false},
    {id: 2,name:'Gasto - IVA 4 %', value:'SOP4', readonly: false},
    {id: 3,name:'Gasto - IVA 10 %', value:'SOP10', readonly: false},
    {id: 4,name:'Gasto - IVA 21 %', value:'SOP21', readonly: false},
    {id: 5,name:'Gasto - Recargo Eq. 1.4 %', value:'RE14', readonly: false},
    {id: 6,name:'Gasto - Recargo Eq. 5.2 %', value:'RE52', readonly: false},
    {id: 7,name:'Gasto - Bienes inversión 21%', value:'BIn21', readonly: false},
    {id: 8,name:'Gasto - Extracomunitaria 10 %', value:'EXT10', readonly: false},
    {id: 9,name:'Gasto - Extracomunitaria 21 %', value:'EXTV', readonly: false},
    {id: 10,name:'Gasto - Inversion sujeto pasivo 21 %', value:'ISP', readonly: false},
    {id: 11,name:'Gasto - Inversion sujeto pasivo 10 %', value:'ISP10', readonly: false},
    {id: 12,name:'Gasto - Intracomunitario Bienes 10 %', value:'UEc10', readonly: false},
    {id: 13,name:'Gasto - Intracomunitario Bienes 21 %', value:'UEcom', readonly: false},
    {id: 14,name:'Gasto - Intracomunitario Servicios 21 %', value:'UEser', readonly: false},

    {id: 15,name:'Venta - IVA extranjero 0 %', value:'EXP', readonly: false},
    {id: 16,name:'Venta - Inversion sujeto pasivo 0 %', value:'ISPC', readonly: false},
    {id: 17,name:'Venta - Exenta 0 %', value:'VEXE', readonly: false},
    {id: 18,name:'Venta - IVA 4 %', value:'REP4', readonly: false},
    {id: 19,name:'Venta - IVA 10 %', value:'REP10', readonly: false},
    {id: 20,name:'Venta - IVA 21 %', value:'REP21', readonly: false},
    {id: 21,name:'Venta - Intracomunitario Servicios 0 %', value:'REPUE', readonly: false},
    {id: 22,name:'Venta - Intracomunitario Bienes 0 %', value:'RPUE0', readonly: false},
    {id: 23,name:'Venta - Recargo Eq. 1.4 %', value:'REQre', readonly: false},
    {id: 24,name:'Venta - Recargo Eq. 5.2 %', value:'REQ', readonly: false},
]

// Additional tax codes for feature_additional_vat_reviso
export const ADDITIONAL_REVISO_TAX_CODES = [
    {id: 25, name:'Venta - No sujeta', value:'REPNS', readonly: false},
    {id: 26, name:'Venta - REBU', value:'REPBU', readonly: false},
]

/**
 * Obtain the tax codes for Reviso based on the feature flag
 * @param hasAdditionalVatFeature - If the feature 'feature_additional_vat_reviso' is enabled
 * @returns Array of tax codes
 */
export function getRevisoTaxCodes(hasAdditionalVatFeature: boolean) {
    if (hasAdditionalVatFeature) {
        return [...REVISO_TAX_CODES, ...ADDITIONAL_REVISO_TAX_CODES]
    }
    return REVISO_TAX_CODES
}